import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {Project} from '../project';
import {ProjectService} from '../project.service';
import {Router} from '@angular/router';
import {WarehouseTypes} from '../warehouse';

@Component({
    selector: 'app-project-list',
    templateUrl: './project-list.component.html',
    styleUrls: ['./project-list.component.css']
})
export class ProjectListComponent implements OnInit, OnChanges {
    projects: Project[] = [];

    @Input() hasFolderId?: boolean;
    @Input() folderId?: number;
    @Output() emitter: EventEmitter<object> = new EventEmitter();

    constructor(private projectService: ProjectService,
                private router: Router) {
    }

    ngOnInit() {
        this.loadProjects();
    }

    ngOnChanges() {
        this.loadProjects();
    }

    loadProjects() {
        if (this.hasFolderId) {
            this.loadFolderProjects();
        } else {
            this.loadRootProjects();
        }
    }

    loadRootProjects() {
        this.projectService.getRootProjects().subscribe(projects => this.projects = projects);
    }

    loadFolderProjects() {
        this.projectService.getFolderProjects(this.folderId).subscribe(projects => this.projects = projects);
    }

    delete(project: Project) {
        this.projects = this.projects.filter(p => p.id !== project.id);
    }

    create() {
        if (this.hasFolderId) {
            this.router.navigate(['/crear-proyecto', {step: 1, folder: this.folderId}]);
        } else {
            this.router.navigate(['/crear-proyecto', {step: 1}]);
        }
    }

    confirmDelete(project: Project) {
        this.emitter.emit({type: 'project-delete', project: project});
    }

    move(project: Project) {
        this.emitter.emit({type: 'project-move', project: project});
    }

    getCaseIconSrc(warehouse_type) {
        const warehouseType = WarehouseTypes[warehouse_type];
        if (warehouseType !== undefined) {
            return WarehouseTypes[warehouse_type].icon;
        } else {
            return 'assets/images/error.png';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/project/project-list/project-list.component.ts